module.exports = __webpack_public_path__ + "static/media/Group 427.07184d4c.svg";